<template>
	<div class="newsletter">
		<p>
			<strong>{{ header }}</strong>
		</p>
		<div v-parse-links v-html="content" />

		<div id="mc_embed_signup">
			<form
				id="mc-embedded-subscribe-form"
				action="https://altenbroek.us20.list-manage.com/subscribe/post?u=b521529c4c6438a654a58038b&id=e04e78873e&f_id=00030ae7f0"
				method="post"
				name="mc-embedded-subscribe-form"
				class="validate newsletter"
				target="_blank"
				novalidate
			>
				<div id="mc_embed_signup_scroll">
					<div class="mc-field-group">
						<input
							id="mce-EMAIL"
							type="email"
							value=""
							name="EMAIL"
							:placeholder="$t('formEmail')"
							class="required email"
						/>
						<input id="mc-embedded-subscribe" type="submit" v name="subscribe" class="arrow" />
					</div>
					<div id="mce-responses" class="clear foot">
						<div id="mce-error-response" class="response" style="display: none"></div>
						<div id="mce-success-response" class="response" style="display: none"></div>
					</div>
					<!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
					<div style="position: absolute; left: -5000px" aria-hidden="true">
						<input type="text" name="b_b521529c4c6438a654a58038b_e04e78873e" tabindex="-1" value="" />
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.newsletter {
	position: relative;

	p {
		margin: 0 auto;
	}

	input {
		appearance: none;
		border-radius: 0;
		font-family: var(--body-font-family);
	}

	input:not(.arrow) {
		color: var(--body-color);
		padding: 0 30px 0 17px;
		line-height: 61px;
		outline: none !important;
		position: relative;
		width: 100%;
		border: 1px solid #1b0906;
	}

	.arrow {
		border: none;
		margin: 0;
		cursor: pointer;
		outline: none;
		position: absolute;
		top: 10px;
		right: 0;
		bottom: 10px;
		width: 40px;
		background: url('~/assets/images/button-arrow-right.svg') no-repeat center center;
		background-size: 11px;
		font-size: 0;
	}
}

::placeholder {
	color: #1b0906;
}

.package-subpage section.newsletter {
	padding: 50px 0;
}

section.newsletter,
.newsletter h2 {
	color: #fff;
}

section.newsletter {
	padding: 50px 0 0;
}

form.newsletter {
	position: relative;
}

@media (max-width: 680px) {
	.newsletter input {
		width: 100%;
		text-align: left;
		font-size: 15px;
		text-transform: lowercase;
	}
}
</style>
